var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M2.502 9.998c0 1.117.25 2.184.692 3.134.175.366.175.791.05 1.183l-.7 2.083a.84.84 0 0 0 1.058 1.059l2.083-.7c.392-.125.817-.125 1.184.05.95.441 2.016.691 3.133.691a7.5 7.5 0 0 0 0-14.998 7.5 7.5 0 0 0-7.5 7.498",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M9.997 11.34a.616.616 0 0 1-.59-.813c.169-.5.664-.874 1.021-1.11.53-.352.536-.71.494-.948a.95.95 0 0 0-.747-.746.94.94 0 0 0-1.113.921.625.625 0 0 1-1.25 0c0-.648.285-1.258.782-1.676a2.2 2.2 0 0 1 1.798-.477c.882.155 1.606.88 1.761 1.762.154.876-.212 1.66-1.032 2.205-.463.307-.527.464-.53.47a.64.64 0 0 1-.594.413m.852 1.574a.833.833 0 0 0-.833-.833h-.008a.83.83 0 0 0-.83.833c0 .46.378.834.838.834s.833-.374.833-.834"
})));
export default SvgChatQuestion;